<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>每日任务配置</span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:dailyReward:add']" type="primary" @click="dialogVisible = true">添加等级</el-button>
            <clear-cache-apply />
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form>
                      </div>
                      <el-form :inline="true">
                        <el-row v-for="(item, score_index) in scoreItem.data" :key="score_index">
                          <el-form-item label="每日任务配置">
                            <el-card class="box-card">
                              <el-form :inline="true">
                                <el-row v-for="(r,i) in item.days" :key="i">
                                  <el-form-item label="某天" style="margin-top: 10px;">
                                    <el-input v-model.number="r.day" style="width: 130px;" placeholder="某天" />
                                  </el-form-item>
                                  <el-form-item style="margin-top: 10px;">
                                    <el-button type="primary" @click="addTask(tabItem.label,scoreItem.group_name, score_index, i)">+</el-button>
                                  </el-form-item>
                                  <el-form-item style="margin-top: 10px;">
                                    <el-button type="danger" @click="delDay(tabItem.label,scoreItem.group_name, score_index, i)">删除</el-button>
                                  </el-form-item>
                                  <el-card class="box-card" style="margin-left: 40px;margin-top: 10px">
                                    <el-row v-for="(t, ti) in r.task" :key="ti">
                                      <el-form-item label="任务类型" style="margin-top: 10px;">
                                        <el-select v-model.number="t.taskId" style="width: 130px;" placeholder="请选择">
                                          <el-option
                                            v-for="(item, index) in taskType"
                                            :key="index"
                                            :label="item.label"
                                            :value="item.value"
                                          />
                                        </el-select>
                                      </el-form-item>
                                      <el-form-item label="奖励类型" style="margin-top: 10px;">
                                        <el-select v-model.number="t.taskRewardType" style="width: 130px;" placeholder="请选择">
                                          <el-option
                                            v-for="(item, index) in taskRewardType"
                                            :key="index"
                                            :label="item.label"
                                            :value="item.value"
                                          />
                                        </el-select>
                                      </el-form-item>
                                      <el-form-item label="奖励进度" style="margin-top: 10px;">
                                        <el-input v-model.number="t.rewardProcess" style="width: 130px;" placeholder="奖励进度" />
                                      </el-form-item>
                                      <el-form-item label="过期时间(分钟)" style="margin-top: 10px;">
                                        <el-input v-model.number="t.expireTime" style="width: 130px;" placeholder="过期时间" />
                                      </el-form-item>
                                      <el-form-item label="奖励配置" style="margin-top: 10px;">
                                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="visibleArr[tabItem.label][scoreItem.group_name][i][ti].visible = true" />
                                        <el-dialog title="奖励配置" :before-close="(d)=>{return handleClose(d, tabItem.label,scoreItem.group_name, ti)}" width="1000px" :visible="visibleArr[tabItem.label][scoreItem.group_name][i][ti].visible">
                                          <el-form>
                                            <el-row v-for="(config, ri) in t.reward" :key="ri">
                                              <el-form-item label="ID" style="margin-top: 10px;">
                                                <el-input v-model.number="config.id" style="width: 60px;" placeholder="id" />
                                              </el-form-item>
                                              <el-form-item label="道具" style="margin-top: 10px;">
                                                <el-select v-model.number="config.prize.propsId" style="width: 100px;" placeholder="请选择">
                                                  <el-option
                                                    v-for="(item, index) in rewardType"
                                                    :key="index"
                                                    :label="item.label"
                                                    :value="item.value"
                                                  />
                                                </el-select>
                                              </el-form-item>
                                              <el-form-item label="奖品数量" style="margin-top: 10px;">
                                                <el-input v-model.number="config.prize.num" style="width: 80px;" placeholder="奖品数量" />
                                              </el-form-item>
                                              <el-form-item style="margin-top: 10px;" label="金币取值">
                                                <el-select v-model.number="config.prize.rtype" :disabled="config.prize.propsId !== 14" placeholder="请选择" style="width: 120px" :prop="'formData.'+index+'.config' +i +'.rtype'">
                                                  <el-option
                                                    v-for="item in selectType"
                                                    :key="item.id"
                                                    :label="item.title"
                                                    :value="item.id"
                                                  />
                                                </el-select>
                                              </el-form-item>
                                              <el-form-item style="margin-top: 10px;" label="权重">
                                                <el-input v-model.number="config.v" style="width: 80px" placeholder="权重" autocomplete="off" />
                                              </el-form-item>
                                              <el-form-item style="margin-top: 10px;">
                                                <el-button v-permisaction="['config:roulette:del']" type="danger" @click="delReward(tabItem.label,scoreItem.group_name,index,i, ti)">删除</el-button>
                                              </el-form-item>
                                            </el-row>
                                          </el-form>
                                          <el-button v-permisaction="['config:roulette:add']" style="margin-top: 10px" type="primary" @click="addReward(tabItem.label,scoreItem.group_name, score_index, i, ti)">+</el-button>
                                          <div slot="footer" class="dialog-footer">
                                            <el-button @click="visibleArr[tabItem.label][scoreItem.group_name][i][ti].visible = false">取 消</el-button>
                                            <el-button type="primary" @click="visibleArr[tabItem.label][scoreItem.group_name][i][ti].visible = false">确 定</el-button>
                                          </div>
                                        </el-dialog>
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;">
                                        <el-button v-permisaction="['config:taskCfg:add']" type="danger" @click="delTask(tabItem.label,scoreItem.group_name, score_index,i,ti)">删除</el-button>
                                      </el-form-item>
                                    </el-row>
                                  </el-card>

                                </el-row>
                                <el-form-item style="margin-top: 10px;">
                                  <el-button v-permisaction="['config:card-process:save']" type="primary" @click="addDay(tabItem.label,scoreItem.group_name, score_index)">+</el-button>
                                </el-form-item>
                              </el-form>
                            </el-card>
                          </el-form-item>
                          <el-form-item label="每周进度配置">
                            <el-card class="box-card">
                              <el-form-item label="过期时间(分钟)">
                                <el-input v-model.number="item.week.expireTime" style="width: 100px;" placeholder="过期时间" />
                              </el-form-item>
                              <el-form :inline="true" style="margin-top: 10px">
                                <el-row v-for="(p, pi) in item.week.stages" :key="pi" style="margin-top: 10px;">
                                  <el-form-item label="步骤">
                                    <el-input v-model.number="p.stage" style="width: 100px;" placeholder="进度" />
                                  </el-form-item>
                                  <el-form-item label="进度">
                                    <el-input v-model.number="p.process" style="width: 100px;" placeholder="进度" />
                                  </el-form-item>
                                  <el-form-item label="奖励配置">
                                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="weekVisibleArr[tabItem.label][scoreItem.group_name][score_index][pi].visible = true" />
                                    <el-dialog title="奖励配置" :before-close="(d)=>{return handleClose(d, tabItem.label,scoreItem.group_name, score_index)}" width="1000px" :visible="weekVisibleArr[tabItem.label][scoreItem.group_name][score_index][pi].visible">
                                      <el-form>
                                        <el-row v-for="(config, i) in p.reward" :key="i">
                                          <el-form-item label="道具" style="margin-top: 10px;">
                                            <el-select v-model.number="config.propsId" style="width: 100px;" placeholder="请选择">
                                              <el-option
                                                v-for="(item, index) in rewardType"
                                                :key="index"
                                                :label="item.label"
                                                :value="item.value"
                                              />
                                            </el-select>
                                          </el-form-item>
                                          <el-form-item label="奖品数量" style="margin-top: 10px;">
                                            <el-input v-model.number="config.num" style="width: 80px;" placeholder="奖品数量" />
                                          </el-form-item>
                                          <el-form-item style="margin-top: 10px;" label="金币取值">
                                            <el-select v-model.number="config.rtype" :disabled="config.propsId !== 14" placeholder="请选择" style="width: 120px" :prop="'formData.'+index+'.config' +i +'.rtype'">
                                              <el-option
                                                v-for="item in selectType"
                                                :key="item.id"
                                                :label="item.title"
                                                :value="item.id"
                                              />
                                            </el-select>
                                          </el-form-item>
                                          <el-form-item style="margin-top: 10px;">
                                            <el-button v-permisaction="['config:dailyReward:del']" type="danger" @click="delWeekReward(tabItem.label,scoreItem.group_name,index, pi,i)">删除</el-button>
                                          </el-form-item>
                                        </el-row>
                                      </el-form>
                                      <el-button v-permisaction="['config:dailyReward:add']" style="margin-top: 10px" type="primary" @click="addWeekReward(tabItem.label,scoreItem.group_name, score_index, pi)">+</el-button>
                                      <div slot="footer" class="dialog-footer">
                                        <el-button @click="weekVisibleArr[tabItem.label][scoreItem.group_name][score_index][pi].visible = false">取 消</el-button>
                                        <el-button type="primary" @click="weekVisibleArr[tabItem.label][scoreItem.group_name][score_index][pi].visible = false">确 定</el-button>
                                      </div>
                                    </el-dialog>
                                  </el-form-item>
                                  <el-form-item>
                                    <el-button type="danger" @click="delWeekStage(tabItem.label,scoreItem.group_name, score_index, pi)">删除</el-button>
                                  </el-form-item>
                                </el-row>
                              </el-form>
                              <el-form-item style="margin-top: 10px;">
                                <el-button type="primary" @click="addWeekStage(tabItem.label,scoreItem.group_name, score_index)">+</el-button>
                              </el-form-item>
                            </el-card>
                          </el-form-item>
                          <!--                          <el-form-item>-->
                          <!--                            <el-button v-permisaction="['config:roulette:del']" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name , score_index,item.id)">1删除</el-button>-->
                          <!--                          </el-form-item>-->
                        </el-row>
                        <!--                        <el-button type="primary" @click="addEvent(tabItem.label,scoreItem.group_name)">+11</el-button>-->
                        <el-button v-permisaction="['config:dailyReward:add']" type="primary" @click="onSubmit()">保存</el-button>
                      </el-form>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getRewardType } from '@/api/config/slot'
import { getDailyRewardCfgList, updateDailyRewardCfg, delFirstCfg } from '@/api/config/daily-reward-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
export default {
  name: 'PopUp',
  components: { ClearCacheApply },
  data() {
    return {
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      taskType: [{
        label: '每日签到',
        value: 1
      }],
      visibleArr: {},
      weekVisibleArr: {},
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      taskRewardType: [{
        label: '固定奖励',
        value: 1
      }, {
        label: '随机奖励',
        value: 2
      }, {
        label: '自选奖励',
        value: 3
      }],
      rewardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],
      popType: [
        { 'label': '推送更新', value: 1 },
        { 'label': '签到', value: 2 }
      ],
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {}
    }
  },
  created() {
    this.getTables()
    this.getRewardTypeData()
  },
  methods: {
    onSubmit(noTips = false) {
      const data = JSON.stringify(this.formData)
      console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          postFormDataCondition[key] = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: scoreItem.group
          }

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }

          const _data = scoreItem.data[0]
          _data.condition = key
          _postData.push(_data)
        }
      }

      console.log(_postData)
      const postCondition = JSON.stringify(postFormDataCondition)
      _postData = JSON.stringify(_postData)
      updateDailyRewardCfg({ name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(d, levelName, scoreName, index) {
      this.visibleArr[levelName][scoreName][index].visible = false
    },
    getTables(actName) {
      console.log('actName', actName)
      getDailyRewardCfgList().then(res => {
        const data = res.data.data
        console.log(data)
        // const tab = {}
        const cond = res.data.cond
        for (const i in cond) {
          const val = cond[i]
          const levelName = val.start + '-' + val.end
          const scoreName = val.groups.join('-')

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.visibleArr, levelName)) {
            this.$set(this.visibleArr, levelName, {})
            this.$set(this.weekVisibleArr, levelName, {})
          }

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          console.log(typeof scoreName)
          if (!Object.prototype.hasOwnProperty.call(this.visibleArr[levelName], scoreName)) {
            this.$set(this.visibleArr[levelName], scoreName, [])
            this.$set(this.weekVisibleArr[levelName], scoreName, [])
          }

          // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
          //   this.$set(this.formData[levelName][scoreName], 'data', [])
          // }

          this.visibleArr[levelName][scoreName].push([{ visible: false }])
          this.weekVisibleArr[levelName][scoreName].push([{ visible: false }])

          this.$set(this.formData[levelName], scoreName, {
            'group': val.groups,
            'group_name': scoreName,
            'group_bak': val.groups,
            data: []
          })

          for (const ii in data) {
            const _event = data[ii]
            console.log('event', _event)
            console.log('ii', _event.condition + ' -- ' + i)
            if (_event.condition === i) {
              // this.visibleArr[levelName][scoreName].push({ visible: false })
              console.log(_event.week)
              _event.week.stages.forEach((res, index) => {
                const key = index.toString()
                if (!Object.prototype.hasOwnProperty.call(this.weekVisibleArr[levelName][scoreName], key)) {
                  this.$set(this.weekVisibleArr[levelName][scoreName], key, [])
                }

                this.weekVisibleArr[levelName][scoreName][key].push({ visible: false })
              })

              _event.days.forEach((res, index) => {
                const key = index.toString()
                if (!Object.prototype.hasOwnProperty.call(this.weekVisibleArr[levelName][scoreName], key)) {
                  this.$set(this.weekVisibleArr[levelName][scoreName], key, [])
                }

                res.task.forEach((item) => {
                  this.weekVisibleArr[levelName][scoreName][key].push({ visible: false })
                })
              })

              this.$set(this.formData[levelName][scoreName], 'data', [{
                id: _event.id,
                days: _event.days,
                week: _event.week
              }])
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }
          console.log('actName', actName)
          if (actName) {
            this.levelActiveName = actName
          } else {
            this.levelActiveName = levelName
          }
        }
      })
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      console.log('old', oldLevelName)
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.visibleArr[oldLevelName]
      Vue.delete(this.visibleArr, oldLevelName)
      this.$set(this.visibleArr, newLevelName, oldVisle)

      // 修改弹窗
      const oldWeekVisle = this.weekVisibleArr[oldLevelName]
      Vue.delete(this.weekVisibleArr, oldLevelName)
      this.$set(this.weekVisibleArr, newLevelName, oldWeekVisle)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addEvent(levelName, scoreName) {
      if (this.formData[levelName][scoreName].data.length > 0) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][scoreName].data.push({
        'task': [
          { taskId: 1, process: 10, reward: [] }
        ],
        'reward': []
      })
      this.visibleArr[levelName][scoreName].push({ visible: false })
      this.weekVisibleArr[levelName][scoreName].push({ visible: false })
      console.log(this.visibleArr[levelName][scoreName])
    },
    delEvent(levelName, scoreName, index, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delFirstCfg({ id: id }).then(res => {
            if (res.code === 200) {
              // this.msgSuccess(res.msg)
              this.$delete(this.formData[levelName], scoreName)
              this.getTables()
            } else {
              // this.msgError(res.msg)
            }
          })
        })
      }

      this.onSubmit(true)
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      console.log(this.formData[score.level_name])
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })

        this.$set(this.visibleArr[score.level_name], scoreTag, [])
        this.$set(this.weekVisibleArr[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 弹窗事件
      this.visibleArr[score.level_name][scoreTag].push([{ visible: false }])
      this.weekVisibleArr[score.level_name][scoreTag].push([{ visible: false }])
      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({
        id: 0,
        days: [{
          day: 1,
          task: [
            {
              taskId: 0,
              taskRewardType: 1,
              rewardProcess: 0,
              expireTime: 0,
              reward: []
            }
          ]
        }],
        week: {
          expireTime: 0,
          stages: [{
            stage: 1,
            process: 1,
            reward: []
          }]
        }
      })

      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        this.msgError('等级已经存在')
        return
      }
      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.visibleArr, levelName, {})
      this.$set(this.weekVisibleArr, levelName, {})
    },
    handleClick(tab, event) {
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(levelName, groupName, index, i, ri) {
      console.log(this.formData[levelName][groupName].data[index].days[i].task[ri])
      if (this.formData[levelName][groupName].data[index].days[i].task[ri].reward.length >= 10) {
        this.msgError('已达上限')
        return
      }
      const len = this.formData[levelName][groupName].data[index].days[i].task[ri].reward.length + 1
      this.formData[levelName][groupName].data[index].days[i].task[ri].reward.push(
        { id: len,
          prize:
            { propsId: 1, num: 1, rtype: 1 }, v: 1
        }
      )
    }, delReward(levelName, groupName, index, i, ri) {
      console.log('删除key', index, i, ri)
      this.formData[levelName][groupName].data[index].days[i].task[ri].reward = this.formData[levelName][groupName].data[index].days[i].task[ri].reward.filter((item, key) => {
        return key !== ri
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.levelActiveName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.visibleArr[levelName][oldGroupName]
      this.$delete(this.visibleArr[levelName], oldGroupName)
      this.$set(this.visibleArr[levelName], newGroupName, oldVisible)

      // 修改弹窗元素
      const oldWeekVisible = this.weekVisibleArr[levelName][oldGroupName]
      this.$delete(this.weekVisibleArr[levelName], oldGroupName)
      this.$set(this.weekVisibleArr[levelName], newGroupName, oldWeekVisible)
    },
    addTask(levelName, groupName, index, i) {
      console.log(this.formData[levelName][groupName].data[index].days[i])
      const d = this.formData[levelName][groupName].data[index].days[i].task.length
      if (d > 2) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][groupName].data[index].days[i].task.push({
        day: d + 1,
        taskId: 1,
        taskRewardType: 1,
        rewardProcess: 0,
        expireTime: 0,
        reward: []
      })
      this.visibleArr[levelName][groupName][index].push({ visible: false })
    },
    delTask(levelName, groupName, index, i, ti) {
      this.formData[levelName][groupName].data[index].days[i].task = this.formData[levelName][groupName].data[index].days[i].task.filter((item, key) => {
        return key !== ti
      })
    },
    addDay(levelName, groupName, index, i) {
      const day = this.formData[levelName][groupName].data[index].days.length
      if (day > 6) {
        this.msgError('已达上限')
        return
      }

      if (!Object.prototype.hasOwnProperty.call(this.visibleArr[levelName][groupName], day)) {
        this.$set(this.visibleArr[levelName][groupName], day, [])
      }

      this.formData[levelName][groupName].data[index].days.push({
        day: day + 1,
        task: [
          {
            taskRewardType: 1,
            rewardProcess: 0,
            expireTime: 0,
            reward: []
          }
        ]
      })

      this.visibleArr[levelName][groupName][day].push({ visible: false })
    },
    delDay(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].days = this.formData[levelName][groupName].data[index].days.filter((item, key) => {
        return key !== i
      })
    }, addWeekStage(levelName, groupName, index) {
      const stage = this.formData[levelName][groupName].data[index].week.stages.length
      if (stage > 6) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][groupName].data[index].week.stages.push({
        stage: stage + 1,
        process: 1,
        reward: []
      })
      this.weekVisibleArr[levelName][groupName][index].push({ visible: false })
    }, delWeekStage(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].week.stages = this.formData[levelName][groupName].data[index].week.stages.filter((res, key) => {
        return i !== key
      })
    }, addWeekReward(levelName, groupName, index, i) {
      console.log(this.formData[levelName][groupName].data[index].week.stages[i])
      this.formData[levelName][groupName].data[index].week.stages[i].reward.push({ propsId: 1, num: 1, rtype: 1 })
    }, delWeekReward(levelName, groupName, index, i, pi) {
      this.formData[levelName][groupName].data[index].week.stages[i].reward = this.formData[levelName][groupName].data[index].week.stages[i].reward.filter((item, key) => {
        return pi !== key
      })
    }
  }
}
</script>

<style scoped>
</style>
